import { useState } from 'react';

const useSearchCriteria = (flightSearchCriteria) => {
  const [searchCriteria, setSearchCriteria] = useState(flightSearchCriteria);
  return { searchCriteria, setSearchCriteria };
};

export default useSearchCriteria;
